<template>
  <div class="fl-general-terms">
    <div class="fl-gt-text-wrapper">
      <i18n-t
        keypath="friendsLight.generalTerms.text"
        tag="p"
        class="fl-gt-text"
      >
        <template #lineBreak>
          <br />
          <br />
        </template>
        <template
          v-if="$te('friendsLight.generalTerms.storefinder')"
          #storefinder
        >
          <fn-link
            inline
            target="_blank"
            :to="$t('friendsLight.generalTerms.storefinder.url')"
          >
            {{ $t('friendsLight.generalTerms.storefinder.text') }}
          </fn-link>
        </template>
        <template
          v-if="$te('friendsLight.generalTerms.friendsExceptions')"
          #friendsExceptions
        >
          <fn-link
            inline
            target="_blank"
            :to="$t('friendsLight.generalTerms.friendsExceptions.url')"
          >
            {{ $t('friendsLight.generalTerms.friendsExceptions.text') }}
          </fn-link>
        </template>
        <template
          v-if="$te('friendsLight.generalTerms.friendsTerms')"
          #friendsTerms
        >
          <fn-link
            inline
            target="_blank"
            :to="$t('friendsLight.generalTerms.friendsTerms.url')"
          >
            {{ $t('friendsLight.generalTerms.friendsTerms.text') }}
          </fn-link>
        </template>
        <template
          v-if="$te('friendsLight.generalTerms.appTerms')"
          #appTerms
        >
          <fn-link
            inline
            target="_blank"
            :to="$t('friendsLight.generalTerms.appTerms.url')"
          >
            {{ $t('friendsLight.generalTerms.appTerms.text') }}
          </fn-link>
        </template>
        <template
          v-if="$te('friendsLight.generalTerms.cgv')"
          #cgv
        >
          <fn-link
            inline
            target="_blank"
            :to="$t('friendsLight.generalTerms.cgv.url')"
          >
            {{ $t('friendsLight.generalTerms.cgv.text') }}
          </fn-link>
        </template>
      </i18n-t>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.fl-general-terms {
  padding: calc(#{$pad} * 2) $pad;

  .fl-gt-text-wrapper {
    p {
      color: palette(grey, 'base');
      font-size: map-get($font-sizes, 's');
      line-height: map-get($font-line-heights, 'xxxs');
      font-weight: map-get($font-weights, 'medium');
    }
  }

  @include bp(m) {
    max-width: $content-max-width;
    padding: $ui-height * 2 0;
  }
}
</style>
